const SafetyIcon75TonTruck = ({ className }: { className?: string } = {}) => (
  <svg
    className={className}
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      fill="white"
    />
    <rect
      x="0.5"
      y="0.5"
      width="35"
      height="35"
      rx="17.5"
      stroke="#269D84"
    />
    <path
      d="M11.9996 25.6008C12.6361 25.6008 13.2466 25.3479 13.6967 24.8978C14.1468 24.4477 14.3996 23.8373 14.3996 23.2008C14.3996 22.5643 14.1468 21.9538 13.6967 21.5037C13.2466 21.0536 12.6361 20.8008 11.9996 20.8008C11.3631 20.8008 10.7526 21.0536 10.3026 21.5037C9.85247 21.9538 9.59961 22.5643 9.59961 23.2008C9.59961 23.8373 9.85247 24.4477 10.3026 24.8978C10.7526 25.3479 11.3631 25.6008 11.9996 25.6008ZM23.9996 25.6008C24.6361 25.6008 25.2466 25.3479 25.6967 24.8978C26.1468 24.4477 26.3996 23.8373 26.3996 23.2008C26.3996 22.5643 26.1468 21.9538 25.6967 21.5037C25.2466 21.0536 24.6361 20.8008 23.9996 20.8008C23.3631 20.8008 22.7526 21.0536 22.3026 21.5037C21.8525 21.9538 21.5996 22.5643 21.5996 23.2008C21.5996 23.8373 21.8525 24.4477 22.3026 24.8978C22.7526 25.3479 23.3631 25.6008 23.9996 25.6008Z"
      stroke="#171717"
      strokeWidth="1.5"
      strokeMiterlimit="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.4 23.2V10.72C20.4 10.529 20.3241 10.3459 20.1891 10.2109C20.0541 10.0759 19.871 10 19.68 10H6.72C6.52904 10 6.34591 10.0759 6.21088 10.2109C6.07586 10.3459 6 10.529 6 10.72V22.48C6 22.5746 6.01862 22.6682 6.05481 22.7555C6.09099 22.8429 6.14402 22.9223 6.21088 22.9891C6.27774 23.056 6.35711 23.109 6.44447 23.1452C6.53182 23.1814 6.62545 23.2 6.72 23.2H9.18M20.4 23.2H14.46M20.4 23.2H21.6M20.4 13.6H27.132C27.2712 13.6 27.4074 13.6404 27.5241 13.7162C27.6408 13.792 27.733 13.9001 27.7896 14.0272L29.9376 18.8608C29.9785 18.9526 29.9998 19.0519 30 19.1524V22.48C30 22.5746 29.9814 22.6682 29.9452 22.7555C29.909 22.8429 29.856 22.9223 29.7891 22.9891C29.7223 23.056 29.6429 23.109 29.5555 23.1452C29.4682 23.1814 29.3746 23.2 29.28 23.2H27"
      stroke="#171717"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M19.0004 13.082V13.823H17.9944V16.8789H17.0695V13.823H16.0635V13.082H19.0004Z"
      fill="#171717"
    />
    <path
      d="M14.2928 13.7371H12.6052V14.4835C12.6774 14.4042 12.7783 14.3392 12.9081 14.2888C13.0379 14.2383 13.1786 14.213 13.33 14.213C13.6004 14.213 13.824 14.2743 14.0007 14.3969C14.181 14.5195 14.3126 14.6782 14.3955 14.8729C14.4785 15.0676 14.5199 15.2786 14.5199 15.5057C14.5199 15.9276 14.4009 16.2629 14.1629 16.5117C13.925 16.7569 13.5896 16.8795 13.1569 16.8795C12.8685 16.8795 12.6179 16.8308 12.4051 16.7335C12.1924 16.6325 12.0283 16.4937 11.9129 16.317C11.7976 16.1403 11.7345 15.9366 11.7236 15.7058H12.6269C12.6485 15.8176 12.7008 15.9114 12.7837 15.9871C12.8667 16.0592 12.9802 16.0953 13.1245 16.0953C13.294 16.0953 13.4202 16.0412 13.5031 15.933C13.586 15.8248 13.6275 15.6806 13.6275 15.5003C13.6275 15.3236 13.5842 15.1884 13.4977 15.0947C13.4111 15.0009 13.2849 14.954 13.1191 14.954C12.9965 14.954 12.8955 14.9847 12.8162 15.046C12.7369 15.1037 12.6846 15.1812 12.6593 15.2786H11.7669V12.9258H14.2928V13.7371Z"
      fill="#171717"
    />
    <path
      d="M10.5107 16.922C10.3484 16.922 10.215 16.8752 10.1104 16.7814C10.0095 16.684 9.95898 16.5651 9.95898 16.4244C9.95898 16.2802 10.0095 16.1594 10.1104 16.062C10.215 15.9647 10.3484 15.916 10.5107 15.916C10.6693 15.916 10.7991 15.9647 10.9001 16.062C11.0047 16.1594 11.0569 16.2802 11.0569 16.4244C11.0569 16.5651 11.0047 16.684 10.9001 16.7814C10.7991 16.8752 10.6693 16.922 10.5107 16.922Z"
      fill="#171717"
    />
    <path
      d="M9.61239 13.6224L8.25481 16.8785H7.30829L8.6821 13.7252H7V12.9355H9.61239V13.6224Z"
      fill="#171717"
    />
  </svg>
)

export default SafetyIcon75TonTruck
